module.exports = __webpack_public_path__ + "img/1.a5701bd1.jpg";